import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class LogoutApi {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_IDENTITY_SERVER')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_IDENTITY_SERVER')));

    return this.api;
  }

  async logoutUser(refreshToken) {
    const result = await this.getAPI().getInstance('application/x-www-form-urlencoded').post('/logout', {refreshToken});
    return result;
  }
}

const api = new LogoutApi();
export default api;
